export { InternalChip } from './InternalChip';
